export enum MonitorTagDialogMessagesEnum {
    UnAssignMonitorTagFromMonitorTitle = 'Unassign this monitor from the current tag',
    UnAssignMonitorFromMonitorTagTitle = 'Unassign this tag from the current monitor',

    TagCreationTitle = 'Tag creation',
    TagUpdatingTitle = 'Tag updating',
    TagdeletingTitle = 'Tag deleting',
    TagTitle = 'Tag',

    SuccessfullyUnAssigned = 'tag was successfully unassigned from ',
    DeleteMonitorTagTitle = 'Delete assigned monitor',

    ConfirmDeleteTitle = 'Deleting tag item'
}
